import axios from './http'
var qs = require('qs');

//个人信息回显
export function httpEdit() {
    return axios({
        url: '/client/user/setup/edit',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
    })
}
//修改个人信息
export function httpUserEdit(data) {
    return axios({
        url: '/client/user/setup/user_edit',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: qs.stringify(data)
    })
}
//修改用户密码
export function httpUserReset(data) {
    return axios({
        url: '/client/user/setup/reset',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: qs.stringify(data)
    })
}
//修改绑定手机
export function httpUserChangephone(data) {
    return axios({
        url: '/client/user/setup/changephone',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: qs.stringify(data)
    })
}
//增值税开票信息列表
export function httpReceipt(page, pagesize, enterprise) {
    let data = {
        page, pagesize, enterprise
    }
    return axios({
        url: '/client/enterprise/receipt',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: qs.stringify(data)
    })
}
//新增增值税开票信息
export function httpCreate(data) {
    return axios({
        url: '/client/enterprise/receipt/create',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: qs.stringify(data)
    })
}
//查看增值税开票信息
export function httpReceiptEdit(receipt_id) {
    let data = {
        receipt_id
    }
    return axios({
        url: '/client/enterprise/receipt/edit',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: qs.stringify(data)
    })
}